import { useEffect, useState } from 'react';
import { applyConsent, getStoredConsent, setStoredConsent } from '../lib/consent';

export function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(getStoredConsent() === null);
  }, []);

  if (!visible) return null;

  const decide = (granted: boolean) => {
    const status = granted ? 'granted' : 'denied';
    setStoredConsent(status);
    applyConsent(status);
    setVisible(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[999] flex flex-col gap-3 border-t border-white/10 bg-black/90 px-4 py-4 backdrop-blur-sm sm:flex-row sm:items-center sm:justify-between sm:px-6">
      <p className="m-0 text-xs text-white/80 sm:whitespace-nowrap sm:text-sm">
        We use cookies to understand product usage and measure campaign performance. See our{' '}
        <a href="/privacy-policy" className="underline">
          Privacy Policy
        </a>
        .
      </p>
      <div className="flex shrink-0 gap-2">
        <button type="button" className="btn btn-ghost !px-4 !py-2 !text-xs" onClick={() => decide(false)}>
          Decline
        </button>
        <button type="button" className="btn btn-primary !px-4 !py-2 !text-xs" onClick={() => decide(true)}>
          Accept
        </button>
      </div>
    </div>
  );
}
